<template>
    <div class="sportageImgSwiper">
      <div class="my-weiper-container" :class="{ 'my-weiper-container-mob': !isPC }">
        <div class="title" data-reveal-text>
          <div class="left-line"></div>
          <div class="main-title">精彩大片，尽享视觉盛宴 </div>
        </div>
        <div class="swiper-container swiper-container-meitu">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{ 'swiper-slide-mob': !isPC }" v-for="(item, index) in imgList" :key="index">
              <img v-img-lazy="origin + item" v-if="shouldLazy(index)" alt="" :data-index="index" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`">
              <img :src="origin + item" v-else alt="" :data-index="index" :code-stm="`event, PAGEURL页面, 查看图片详情${item}`">
            </div>
          </div>
          <div v-if="!isPC && imgList && imgList.length > 1" class="swiper-button-next" :class="{ 'swiper-button-mob': !isPC }"
            id="swiper-button-next-meitu" :code-stm="`event, PAGEURL页面, 轮播下一页`">
          </div>
          <div v-if="!isPC && imgList && imgList.length > 1" class="swiper-button-prev" :class="{ 'swiper-button-mob': !isPC }"
            id="swiper-button-next-meitu" :code-stm="`event, PAGEURL页面, 轮播上一页`">
          </div>
          <div class="swiper-pagination swiper-pagination-meitu" :class="{ 'swiper-pagination-mob': !isPC }"></div>
        </div>

        <div class="cover" v-if="isShowCover">
          <i class="el-icon-close" :class="{ 'el-icon-close-mob': !isPC }" @click.stop="hideCover"
            :code-stm="`event, PAGEURL页面, 关闭弹窗`"></i>
          <div class="pop">
            <div class="swiper-container2" :class="{ 'swiper-container2-mob': !isPC }">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in imgList" :key="index + 'cover'">
                   <img :src="origin + item" alt="">

                </div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination swiper-pagination2"></div>
            <!-- Add Arrows -->
            <div class="swiper-button-next swiper-button-next2" :code-stm="`event, PAGEURL页面, 弹窗轮播下一页`"></div>
            <div class="swiper-button-prev swiper-button-prev2" :code-stm="`event, PAGEURL页面, 弹窗轮播上一页`"></div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import Swiper from "swiper";
  import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
  import { ImgBaseUrl } from "@/config/base.js";
  export default {
    data() {
      return {
        isPortrait: isPortraitFun(),
        isPC: isPc(),
        imgList: [],
        imgListPc: [
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-01.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-02.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-03.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-04.png',
          /**
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-05.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-06.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-07.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-08.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-09.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-pc-10.png',
           **/
        ],
        imgListMob: [
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-01.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-02.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-03.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-04.png',
  /**
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-05.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-06.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-07.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-08.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-09.png',
          '/assets/~/media/images/vehicle/new-sportage/morepics/img-mob-10.png',
   **/
        ],
        isShowCover: false,
        swiperCover: null,
        origin:ImgBaseUrl
      };
    },
    mounted: function () {
      this.imgList = !this.isPC ? this.imgListMob : this.imgListPc
      this.$nextTick(() => {
        if (this.isPC) {
          var swiper = new Swiper('.swiper-container-meitu', {
            slidesPerView: 2.5,
            spaceBetween: 40,
            centeredSlides: false,
            loop: false,
            preloadImages: false,
            updateOnImagesReady: true,
            pagination: {
              el: '.swiper-pagination-meitu',
              type: 'progressbar'
            },
            mousewheel: true
          });
          window.addEventListener("click", this.showCover)
        } else {
          var swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            loop: false,
            preloadImages: false,
            updateOnImagesReady: true,
            lazy: {
              loadOnTransitionStart: true,
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '#swiper-button-next-meitu',
              prevEl: '#swiper-button-prev-meitu',
            },
            on: {
              slideChange: function() {
                // 控制导航按钮的显示/隐藏
                const prevButton = document.getElementById('swiper-button-prev-meitu');
                const nextButton = document.getElementById('swiper-button-next-meitu');

                if (prevButton && nextButton) {
                  // 如果是第一张图片，隐藏左滑按钮
                  if (this.isBeginning) {
                    prevButton.style.display = 'none';
                  } else {
                    prevButton.style.display = 'block';
                  }

                  // 如果是最后一张图片，隐藏右滑按钮
                  if (this.isEnd) {
                    nextButton.style.display = 'none';
                  } else {
                    nextButton.style.display = 'block';
                  }
                }
              }
            }
          });

          // 初始化时检查第一张图片的状态
          this.$nextTick(() => {
            if (swiper && swiper.isBeginning) {
              const prevButton = document.getElementById('swiper-button-prev-meitu');
              if (prevButton) {
                prevButton.style.display = 'none';
              }
            }
          });
          window.addEventListener("click", this.showCover)
        }
        this.swiperCover = new Swiper('.swiper-container2', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          pagination: {
            el: '.swiper-pagination2',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.swiper-button-next2',
            prevEl: '.swiper-button-prev2',
          },
        });
      })
    },
    methods: {
      shouldLazy(index) {
        return index >= 2 && index < this.imgList.length - 1;
      },
      showCover(e) {
        const index = e.target.getAttribute('data-index')
        console.log('点击的data-index:', index);
        console.log('当前imgList:', this.imgList);
        console.log('点击的图片src:', e.target.src);
        if (index) {
          this.isShowCover = true
          this.$nextTick(() => {
            this.swiperCover = new Swiper('.swiper-container2', {
              initialSlide: index,
              slidesPerView: 1,
              spaceBetween: 0,
              loop: false,
              pagination: {
                el: '.swiper-pagination2',
                type: 'fraction'
              },
              navigation: {
                nextEl: '.swiper-button-next2',
                prevEl: '.swiper-button-prev2',
              },
            });
          })
          window.removeEventListener("click", this.showCover)
          //开始全屏预览
           window.parent.postMessage({ type: 'sportageImgSwiperOpen' }, '*')
        }
      },
      hideCover() {
        this.isShowCover = false
        this.swiperCover = null
        window.addEventListener("click", this.showCover);
          //关闭全屏预览
        window.parent.postMessage({ type: 'sportageImgSwiperClose' }, '*')
      }
    },
  };
  </script>

  <style lang="scss" scoped>
  @import "swiper/css/swiper.css";

  .my-weiper-container {
    position: relative;
    height: 100%;
    width: 100%;
    user-select: none;
    padding-bottom: 20px;
    padding: 0 6%;
    .swiper-container {
      display: flex;
      align-items: center;
    }
    img {
      width: 100%;
      height: auto;
    }

    .swiper-container {
      position: relative;
      width: 100%;
      height: auto;
      padding-bottom: 45px;
      /* overflow: visible; */
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #eee;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: 300ms;
      cursor: pointer;

      &-mob {
        transform: scale(1);
      }
    }

    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
    }

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
      bottom: -45px;
    }

    .swiper-container-horizontal>.swiper-pagination-progressbar,
    .swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
      top: unset;
      height: 2px;
      bottom: 0;
      background: rgba(0, 0, 0, 0.1) !important;
    }

    ::v-deep .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      background: #05141f !important;
    }

    ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
      .swiper-pagination-bullet {
        width: 32px;
        height: 2px;
        background: #05141F;
        border-radius: 0;
      }

      .swiper-pagination-bullet-active {
        width: 48px;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      width: 2.91666vw;
      height: 2.91666vw;
      background: rgba($color: #fff, $alpha: 0.8);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);

      &::after {
        /* content: none; */
        font-size: 16px;
        font-weight: 900;
        color: rgba(5, 20, 31, 0.8);
      }

      &:hover {
        background: rgba($color: #05141F, $alpha: 0.8);
      }

      &:hover::after {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .swiper-button-prev,
    .swiper-button-next:focus {
      outline: none;
    }

    .swiper-button-next {
      right: 2%;
    }

    .swiper-button-prev {
      left: 2%;
    }

    &-mob {
      padding: 0;

      .title {
        padding: 10px 5%;
        font-size: 28px;
      }

      .swiper-container {
        padding: 0;
      }

      .swiper-pagination-fraction,
      .swiper-pagination-custom,
      .swiper-container-horizontal>.swiper-pagination-bullets {
        bottom: -20px;
      }

      ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
        .swiper-pagination-bullet {
          width: 8px;
          height: 2px;
          background: #05141F;
          border-radius: 0;
        }

        .swiper-pagination-bullet-active {
          width: 16px;
        }
      }

      .swiper-button-mob {
        width: 30px;
        height: 30px;
        background: rgba($color: #000000, $alpha: 0);
        color: #fff;
        font-size: 30px;
        font-weight: bold;
        transform: translateY(0);
        top:45%;
        &::after {
          font-size: 16px;
          font-weight: 900;
          color: #fff;
        }

        &:hover {
          background: rgba($color: #000000, $alpha: 0);
        }

        &:hover::after {
          color: #fff;
        }
      }
    }

    /* @media screen and (orientation: portrait) {
      padding: 20px 0 25px;
      .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: -20px;
      }
    } */

    .cover {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: #000000;
      z-index: 10;

      .el-icon-close {
        color: #fff;
        font-size: 40px;
        cursor: pointer;
        position: absolute;
        z-index: 99;
        right: 50px;
        top: 50px;

        &-mob {
          font-size: 30px;
          right: 20px;
        }
      }

      .pop {
        position: relative;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .swiper-container2 {
        width: 70vw;
        height: auto;
        overflow: hidden;

        /* position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden; */
        /* height: 80%; */
        .swiper-slide {
          background: rgba($color: #000000, $alpha: 0);

          img {
            width: 78%;
            height: auto;
          }

          @media (max-width: 768px) {
            img {
              width: 100%;
            }
          }
        }

        &-mob {
          width: 100vw;
        }
      }

      .swiper-pagination-fraction {
        position: absolute;
        z-index: 999;
        bottom: -30px;
        color: #fff;
      }

      .swiper-button-next,
      .swiper-button-prev {
        background: rgba($color: #000, $alpha: 0);
        transition: all .5s;
        color: #fff;
        font-size: 30px;
        font-weight: bold;
        transform: translateY(-50%);

        &::after {
          /* content: none; */
          font-size: 30px;
          font-weight: 400;
          color: #fff;
        }

        &:hover {
          background: rgba($color: #05141F, $alpha: 0);
        }

        &:hover::after {
          color: #fff;
        }
      }

      .swiper-button-prev,
      .swiper-button-next:focus {
        outline: none;
      }

      .swiper-button-next2 {
        right: 0;
        transform: translateY(-25%);
      }

      .swiper-button-prev2 {
        left: 0;
        transform: translateY(-25%);
      }

      @media (max-width: 768px) {
        .swiper-button-next2 {
          width: auto;
          height: auto;
          right: 2%;
          transform: translateY(25%);
        }

        .swiper-button-prev2 {
          width: auto;
          height: auto;
          left: 2%;
          transform: translateY(25%);
        }
      }
    }
  }

  .title {
    display: flex;
    padding-left: calc(2.291667vw);
    padding-bottom: 2.135417vw;
    padding-top: 2.135417vw;

    font-family: FZLanTingHeiS-DB-GB !important;
    font-size: calc(39 / 375 * 100vw) !important;


    .left-line {
      width: 0.208333vw;
      height: 2.1875vw;
      background: rgba(217, 217, 217, 1);
      opacity: 1;
      // border: 4px solid #3A88BC;
      margin-right: 2.708333vw;
    }

    .main-title {
      font-family: 'chuhei';
      font-size: 2.083333vw;
      padding-bottom: 1.458333vw;
      line-height:2.1875vw;
    }

    .sub-title {
      font-size: 1.5625vw;
    }
  }
  .my-weiper-container-mob .title{
    padding:calc(150/750*100vw) 0 calc(120/750*100vw) calc(50/750*100vw);
    display: flex;
    align-items: center;
    .left-line{
      width:calc(5/750*100vw);
      height:calc(49/750*100vw);
      margin-right:calc(35/750*100vw);
    }
    .main-title{
      font-size:calc(48/750*100vw);
    }
  }
  .sportageImgSwiper {
    height: 42vw;
  }
  @media (min-width: 768px) {
    .left-line {
      background: rgba(217, 217, 217, 1);
    }
    .title {
      font-family: FZLanTingHeiS-DB-GB !important;
      font-size: calc(39 / 375 * 100vw) !important;
      padding-left: 0 !important;
    }
  }

  @media (max-width: 768px) {
    .title {
      font-family: FZLanTingHeiS-DB-GB !important;
      font-size: calc(21 / 375 * 100vw) !important;
    }
    .left-line {
      //display: none !important;
    }
  }

  </style>
